
<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <data-view-lapangan :isSidebarActive="addNewDataLapangan" @closeSidebar="toggleDataLapangan" :data="lapanganData" />

    <data-view-gabungan :isSidebarActive="addNewDataGabungan" @closeSidebar="toggleDataGabungan" :data="gabunganData" />

    <vs-table 
    ref="table"
    :total="analisaTotal"
    :max-items="itemsPerPage" 
    :data="analisaData">

      <template slot="header">

        <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse">
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-plus" @click="addNewData" v-can="'A'" class="p-3 mb-4 mr-4">Analisa Satuan</vs-button>
            <!--
            <vs-button color="success" type="border" icon-pack="feather" icon="icon-plus" @click="addNewLapangan" v-can="'A'" class="p-3 mb-4 mr-4">Analisa Lapangan</vs-button>
            <vs-button color="warning" type="border" icon-pack="feather" icon="icon-plus" @click="addNewGabungan" v-can="'A'" class="p-3 mb-4 mr-4">Analisa Gabungan</vs-button>
            -->

            <vs-button color="dark" type="filled" icon-pack="feather" icon="icon-printer" @click="printData()" v-can="'A'" class="p-3 mb-4 mr-4">Export or Print</vs-button>

            <!--
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-file-text" @click="addNewData" v-can="'A'" class="p-3 mb-4 mr-4">Export</vs-button>
            -->
          </div>

          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Satuan Pekerjaan" v-model="searchData" class="is-label-placeholder mb-4" v-on:keyup.enter="pageParam()"/>
            <!--
            <vs-dropdown class="cursor-pointer mb-4">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2" v-if="pekerjaanNama === null">Filter</span>
                <span class="mr-2" v-else>{{pekerjaanNama}}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item v-for="kerja in Pekerjaans" :key="kerja.id" value="kerja.id" @click="pageParam(searchData, kerja.id, kerja.name)">
                  <span>{{kerja.name}}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            -->
          </div>
        </div>

        <vs-row>
          <vs-col vs-align="center" class="p-2" vs-type="flex" vs-justify="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <vs-select
              class="w-full"
              label="Bidang"
              v-model="dataFilterBidang"
              @change="filterDivisi"
              >
                <vs-select-item value="empty" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listFilterBidang"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="p-2" vs-type="flex" vs-justify="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <vs-select
              class="w-full"
              label="Divisi"
              v-model="dataFilterDivisi"
              @change="filterKelompok"
              >
                <vs-select-item value="empty" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listFilterDivisi"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="p-2" vs-type="flex" vs-justify="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <vs-select
              class="w-full"
              label="Kelompok"
              v-model="dataFilterKelompok"
              @change="filterSub"
              >
                <vs-select-item value="empty" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listFilterKelompok"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="p-2" vs-type="flex" vs-justify="center" vs-lg="3" vs-sm="4" vs-xs="12">
            <vs-select
              class="w-full"
              label="Sub Pekerjaan"
              v-model="dataFilterSub"
              >
                <vs-select-item value="empty" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listPekerjaan"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center"  class="p-2" vs-type="flex" vs-justify="center" vs-lg="2" vs-sm="4" vs-xs="12">
            <vs-button id="button-load-filter" class="w-full mt-6" @click.native="pageParam()">Filter</vs-button>
          </vs-col>
        </vs-row>


        <!-- ITEMS PER PAGE 
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ analisaData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : analisaData.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        -->
      </template>

      <template slot="thead">
        <vs-th sort-key="pekerjaan">Kode</vs-th>
        <vs-th sort-key="analisa">Analisa</vs-th>
        <vs-th>Harga Satuan</vs-th>
        <vs-th v-can="'E'">Edit</vs-th>
        <vs-th v-can="'D'">Delete</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.kode }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">{{ tr.task_title }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name truncate">{{ tr.task_total | currency }} / {{ tr.nama_satuan }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" v-can="'E'"/>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteConfirm(tr.id, tr.task_title)" v-can="'D'"/>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex justify-between mt-base px-5">
          <h4>{{ analisaData.length }} dari {{ analisaTotal }} AHSP</h4>

          <vs-button v-if="nextButton" id="button-load-more-posts" class="vs-con-loading__container" @click.native="pageNext">Load More</vs-button>
        </div>
      </div>
    </div>

    <vs-prompt
      color="danger"
      title="Konfirmasi"
      @accept="deleteData(hapusId, hapusAnalisa)"
      @close="close"
      :active.sync="hapus">
      <div class="con-exemple-prompt">
        Yakin ingin menghapus analisa {{ hapusAnalisa }}
      </div>
    </vs-prompt>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="pekerjaanNama"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
      >
      <section slot="pdf-content" class="cetak mx-12">
          <section :key="indexC" v-for="(cetak, indexC) in analisaCetak" class="pdf-item pb-8 pt-2">
            <h4 class="mb-2 mt-2">{{cetak.kode}} {{cetak.task_title}}</h4>
            <table style="width:100%">
              <tr>
                <th align="center">No</th>
                <th align="center">Uraian</th>
                <th align="center">Kode</th>
                <th align="center">Satuan</th>
                <th align="center">Koefisien</th>
                <th align="center">Harga Satuan</th>
                <th align="center">Jumlah Harga</th>
              </tr>
              <tr>
                <td align="center">A</td>
                <td>TENAGA</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr :key="`${indexT}-tenaga`" v-for="(tenaga, indexT) in cetak.tenaga">
                <td></td>
                <td>{{tenaga.task_title}}</td>
                <td>{{tenaga.kode}}</td>
                <td>{{tenaga.term_satuan}}</td>
                <td>{{tenaga.task_quantity}}</td>
                <td>{{tenaga.task_price | currency }}</td>
                <td>{{tenaga.task_total | currency }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Jumlah Tenaga Kerja</td>
                <td>{{cetak.total_tenaga | currency }}</td>
              </tr>
              <tr>
                <td align="center">B</td>
                <td>BAHAN</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr :key="`${indexB}-bahan`" v-for="(bahan, indexB) in cetak.bahan">
                <td></td>
                <td>{{bahan.task_title}}</td>
                <td>{{bahan.kode}}</td>
                <td>{{bahan.term_satuan}}</td>
                <td>{{bahan.task_quantity}}</td>
                <td>{{bahan.task_price | currency }}</td>
                <td>{{bahan.task_total | currency }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Jumlah Harga Bahan</td>
                <td>{{cetak.total_bahan | currency }}</td>
              </tr>
              <tr>
                <td align="center">C</td>
                <td>ALAT</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr :key="`${indexA}-alat`" v-for="(alat, indexA) in cetak.alat">
                <td></td>
                <td>{{alat.task_title}}</td>
                <td>{{alat.kode}}</td>
                <td>{{alat.term_satuan}}</td>
                <td>{{alat.task_quantity}}</td>
                <td>{{alat.task_price | currency }}</td>
                <td>{{alat.task_total | currency }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Jumlah Harga Alat</td>
                <td>{{cetak.total_alat | currency }}</td>
              </tr>
              <tr>
                <td class="py-3"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td align="center">D</td>
                <td colspan="5">Jumlah (A+B+C)</td>
                <td>{{ cetak.task_price | currency }}</td>
              </tr>
              <tr>
                <td align="center">E</td>
                <td colspan="3">Overhead &nbsp; Profit ({{ cetak.persentase | currency }}%)</td>
                <td colspan="2">{{ cetak.persentase | currency }}% x {{ cetak.task_price | currency }}</td>
                <td>{{ cetak.profit | currency }}</td>
              </tr>
              <tr>
                <td align="center">F</td>
                <td colspan="5"><b>Harga Satuan Pekerjaan (D+E)</b></td>
                <td><b>{{ cetak.task_total | currency }}</b></td>
              </tr>
            </table>
            <div v-if="(indexC%2)==1" class="html2pdf__page-break"/>
          </section>
      </section>
    </vue-html2pdf>

    <div class="pro-vs-loading px-12" v-if="onPro">
      <vs-progress :percent="onPercent" color="primary" class="mx-8">primary</vs-progress>
    </div>

  </div>
</template>

<script>
import DataViewSidebar from './AnalisaSidebar.vue'
import DataViewLapangan from './AnalisaLapangan.vue'
import DataViewGabungan from './AnalisaGabungan.vue'
import analisaModule from '@/stores/proyek/analisa.js'
import { mapGetters } from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    DataViewSidebar,
    DataViewLapangan,
    DataViewGabungan,
    VueHtml2pdf
  },
  data () {
    return {
      nextButton: true,
      selected: [],
      // analisas: [],
      pageTable: 1,
      itemsPerPage: 10,
      isMounted: false,
      Pekerjaans: [],
      pekerjaan: null,
      pekerjaanNama: null,
      pekerjaanID:null,
      searchData:null,

      dataFilterBidang: 'empty',
      dataFilterDivisi: 'empty',
      dataFilterKelompok: 'empty',
      dataFilterSub: 'empty',

      listFilterBidang: [],
      listFilterDivisi: [],
      listFilterKelompok: [],
      listPekerjaan: [],

      Filter: null,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      addNewDataLapangan: false,
      lapanganData: {},
      addNewDataGabungan: false,
      gabunganData: {},
      hapus: false,
      hapusId: null,
      hapusAnalisa: null,

      analisaCetak: [],
      onPercent: 2,
      onPro: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    analisaData () {
      return this.$store.state.analisa.analisas
    },
    analisaTotal () {
      return this.$store.state.analisa.total
    },
    analisaLast () {
      return this.$store.state.analisa.last
    },
    /*
    analisaCetak () {
      return this.$store.state.analisa.cetak
    },
    */
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.analisaData.length
    },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  methods: {
    filterDivisi () {
      this.dataFilterDivisi = 'empty'
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-parent/'+this.dataFilterBidang, configs).then((response) => {
        let {data} = response.data
        this.listFilterDivisi = data
      })
      this.Filter = {
        bidang: this.dataFilterBidang,
        divisi: this.dataFilterDivisi,
        kelompok: 'empty',
        pekerjaan: 'empty'
      }
    },
    filterKelompok () {
      this.dataFilterKelompok = 'empty'
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-parent/'+this.dataFilterDivisi, configs).then((response) => {
        let {data} = response.data
        this.listFilterKelompok = data
      })
      this.Filter = {
        bidang: this.dataFilterBidang,
        divisi: this.dataFilterDivisi,
        kelompok: this.dataFilterKelompok,
        pekerjaan: 'empty'
      }
    },
    filterSub () {
      this.dataFilterSub = 'empty'
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-parent/'+this.dataFilterKelompok, configs).then((response) => {
        let {data} = response.data
        this.listPekerjaan = data
      })
      this.Filter = {
        bidang: this.dataFilterBidang,
        divisi: this.dataFilterDivisi,
        kelompok: this.dataFilterKelompok,
        sub: this.dataFilterSub,
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addNewLapangan () {
      this.lapanganData = {}
      this.toggleDataLapangan(true)
    },
    addNewGabungan () {
      this.gabunganData = {}
      this.toggleDataGabungan(true)
    },
    deleteConfirm(id, analisa) {
      this.hapusId = id
      this.hapusAnalisa = analisa
      this.hapus = true
    },
    deleteData (id) {
      this.$store.dispatch('analisa/removeTask', id)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      if (data.task_group === 'sni') {
        this.sidebarData = data
        this.toggleDataSidebar(true)
      } else if (data.task_group === 'lapangan') {
        this.lapanganData = data
        this.toggleDataLapangan(true)
      } else if (data.task_group === 'gabungan') {
        this.gabunganData = data
        this.toggleDataGabungan(true)
      }
      /*

      this.sidebarData = {
        data: data,
        list_satuan: this.listSatuan,
        list_tenaga: this.listTenaga,
        list_bahan: this.listBahan,
        list_alat:  this.listAlat
      }
      */
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleDataLapangan (val = false) {
      this.addNewDataLapangan = val
    },
    toggleDataGabungan (val = false) {
      this.addNewDataGabungan = val
    },
    close() {
      this.$emit('closed', false)
    },
    pageNext () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-load-more-posts',
        scale: 0.45
      })
      const obj = {
        action: 'next',
        page: parseInt(this.pageTable)+1,
        search: this.searchData,
        bidang: this.dataFilterBidang,
        divisi: this.dataFilterDivisi,
        kelompok: this.dataFilterKelompok,
        sub: this.dataFilterSub
      }
      this.pageTable++
      if (this.pageTable <= this.analisaLast) {
        setTimeout(() => {
          this.$store.dispatch('analisa/fetchAnalisa', obj)
          this.$vs.loading.close('#button-load-more-posts > .con-vs-loading')
        }, 2000)
      } else {
        setTimeout(() => {
          this.$vs.loading.close('#button-load-more-posts > .con-vs-loading')
          this.nextButton = false
          this.$vs.notify({
            title: 'Sudah tidak ada',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }, 2000)
      }
    },
    pageParam () {
      this.pageTable = 1
      if (this.searchData === '') {
        this.searchData = null
      }
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '.vs-con-table',
        scale: 0.45
      })
      const obj = {
        action: 'create',
        page: this.pageTable,
        search: this.searchData,
        bidang: this.dataFilterBidang,
        divisi: this.dataFilterDivisi,
        kelompok: this.dataFilterKelompok,
        sub: this.dataFilterSub
      }
      setTimeout(() => {
        this.$store.state.analisa.analisas = []
        this.$store.state.analisa.total = null
        this.$store.state.analisa.last = null
        this.nextButton = true
        this.$store.dispatch('analisa/fetchAnalisa', obj)
        this.$vs.loading.close('.vs-con-table > .con-vs-loading')
      }, 2000)
    },
    onProgress (event) {
      this.onPro = true
      this.onPercent = event
      /*
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '.vs-con-table',
        scale: 0.45
      })
      */
      if (event === 100) {
        //this.$vs.loading.close('.vs-con-table > .con-vs-loading')
        this.onPro = false
        this.onPercent = 2
      }
    },
    printData () {
      //if (this.dataFilterBidang != 'empty') {
        const obj = {
          search: this.searchData,
          bidang: this.dataFilterBidang,
          divisi: this.dataFilterDivisi,
          kelompok: this.dataFilterKelompok,
          sub: this.dataFilterSub
        }
        let config = {
          headers: {
              'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        this.analisaCetak = []
        this.axios.get(`/task-cetak-analisa/${obj.search}/${obj.bidang}/${obj.divisi}/${obj.kelompok}/${obj.sub}`, config)
        .then((response) => {
          let {data} = response.data
          this.analisaCetak = data
          this.$refs.html2Pdf.generatePdf()
        })
        .catch((error) => {
          this.analisaCetak = []
          let {data} = error.response
          this.$vs.notify({
            title: 'Error',
            text  : data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      /*
      } else {
        this.$vs.notify({
          title: 'Pilih filter',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }*/
    }
  },
  created () {
    if (!analisaModule.isRegistered) {
      this.$store.registerModule('analisa', analisaModule)
      analisaModule.isRegistered = true
    }
    const obj = {
      action: 'create',
      page: this.pageTable,
      search: null,
      filter: null,
      
      bidang: this.dataFilterBidang,
      divisi: this.dataFilterDivisi,
      kelompok: this.dataFilterKelompok,
      sub: this.dataFilterSub
    }
    this.$store.dispatch('analisa/fetchAnalisa', obj)

    this.listFilterBidang = []
    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list/pekerjaan_bidang', configs).then((response) => {
      let {data} = response.data
      this.listFilterBidang = data
    })
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
.cetak {
  table, th {
    border: 1px solid black;
    border-collapse: collapse;
  }
  td {
    padding-left: 4px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-collapse: collapse;
  }
}
#data-list-list-view {
  .vs-con-table {
    .vs-con-input-label.is-label-placeholder {
      margin-top: 0px;
    }

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

  .pro-vs-loading {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: hsla(0,0%,100%,.6);
    z-index: 300000;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
  }
}
</style>
